export enum TenantStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum TenantEnum {
  ROOT = "root"
}

export enum TypeDatabase {
  PreBuiltSharedDatabase = "PreBuiltSharedDatabase",
  PreBuiltDedicatedDatabase = "PreBuiltDedicatedDatabase",
  OnPremiseShareDatabase = "OnPremiseShareDatabase",
  OnPremiseCustomDatabase = "OnPremiseCustomDatabase",
}

export const MapTypeDatabase: Record<TypeDatabase | string, string> = {
  [TypeDatabase.PreBuiltSharedDatabase]: "Pre-built shared database",
  [TypeDatabase.PreBuiltDedicatedDatabase]: "Pre-built dedicated database",
  [TypeDatabase.OnPremiseShareDatabase]: "On-premise share database",
  [TypeDatabase.OnPremiseCustomDatabase]: "On-premise custom database"
}